<template>
    <div>
        <el-container>
            <el-header id="header-container">
                <div class="header-title" style="font-size: 18px; flex-shrink: 0; cursor: pointer; width: 280px;"
                    @click="$store.state.tabActive = 0">
                    排量后台管理系统 - 平台端</div>
                <div style="flex-grow: 1; width: 600px;">
                    <el-menu :default-active="menuActive" mode="horizontal" @select="menuSelect"
                        background-color="#545c64" text-color="#fff" active-text-color="#ffd04b">
                        <el-menu-item :index="menu.id" v-for="menu in menus">{{ menu.name }}</el-menu-item>
                    </el-menu>
                </div>
                <div class="header-extend"
                    style="display: flex; width: 100%; flex-direction: row-reverse; align-items: center;">
                    <div class="header-admin"
                        style="margin-right: 20px; display:flex; color: #ffffff; align-items: center;">
                        <img src="@/assets/img/user-icon.png" alt=""
                            style="width: 30px; height: 30px; margin-right: 10px;">
                        <div style="font-size: 14px;">欢迎光临：{{ name }}，</div>
                        <div style="font-size: 14px; cursor: pointer;" @click="isPassword = true">[修改密码]，</div>
                        <div style="font-size: 14px; cursor: pointer;" @click="outClick()">[点此退出]</div>
                    </div>
                </div>
            </el-header>
            <el-container>
                <el-main id="aside-content" style="background-color: #f8f8f9;">
                    <keep-alive>
                        <router-view :key="$route.fullPath"></router-view>
                    </keep-alive>
                </el-main>
            </el-container>
        </el-container>
        <!-- 修改密码 -->
        <el-dialog title="修改密码" :visible.sync="isPassword" width="30%" :close-on-click-modal="false">
            <el-form ref="form" :model="passwordForm" label-width="90px">
                <el-form-item label="原始密码">
                    <el-input v-model="passwordForm.oldPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="输入新密码">
                    <el-input v-model="passwordForm.newPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="确认新密码">
                    <el-input v-model="passwordForm.confirmPassword" type="password"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isPassword = false">取 消</el-button>
                <el-button type="primary" @click="updatePassword()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { API, doGet, doPost } from "@/api/api.js"
import verifyMixin from "@/mixins/verify-mixin.js"

export default {
    mixins: [verifyMixin],
    data: function () {
        return {
            menuActive: 1,
            defaultOpeneds: [],
            name: "",
            menus: [
                {
                    id: 1,
                    name: "商户信息管理",
                    url: "/Company/List"
                },
                {
                    id: 2,
                    name: "商户权限管理",
                    url: "/Permission/List"
                },
            ],
            isPassword: false,
            passwordForm: {
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
                type: 1
            }
        }
    },
    methods: {
        menuSelect: function(e) {
            this.menuActive = e;
            this.$router.push(this.menus[e - 1].url);
        },
        tabClick: function (tab) {
            this.$store.state.tabActive = this.$store.state.tabs[tab.index].sysPermissionId;
        },
        getData: async function () {
            //this.menus = await doGet(API.TREE.PERMISSION);
            let dataObj = await doGet(API.PUBLIC.INDEX, { type: 1 });
            if (dataObj != null) {
                this.name = dataObj.adminName;
                if (dataObj.premissionTree && dataObj.premissionTree.length > 0) {
                    this.menus = dataObj.premissionTree;
                    let menuOpenIds = [];   //默认展开的菜单
                    if (this.menus.length > 0) {
                        for (let i = 0; i < this.menus.length; i++) {
                            if (this.menus[i].children && this.menus[i].children.length > 0) {
                                menuOpenIds.push(this.menus[i].sysPermissionId);
                            }
                        }
                    }
                    this.defaultOpeneds = menuOpenIds;
                }
                if (this.name) {
                    this.$router.push("/Company/List");
                }
            }
        },
        removeTab: function (e) {
            for (var i = 0; i < this.$store.state.tabs.length; i++) {
                let deleteIndex = 0;
                if (this.$store.state.tabs[i].sysPermissionId == e) {
                    this.$store.state.tabs.splice(i, 1);
                    this.$store.state.tabActive = this.$store.state.tabs[i - 1].sysPermissionId;
                    break;
                }
            }
        },
        menuClick: function (menu) {
            var isExist = false;
            for (let i = 0; i < this.$store.state.tabs.length; i++) {
                if (this.$store.state.tabs[i].sysPermissionId == menu.sysPermissionId) {
                    isExist = true;
                    break;
                }
            }
            if (!isExist) {
                this.$store.commit('addTab', menu);
            }
            else {
                this.$store.state.tabActive = menu.sysPermissionId;
            }
        },
        outClick: function () {
            localStorage.setItem("COIN-AUTH", null);
            location.href = "/login";
        },
        updatePassword: async function () {
            let resultObj = await doPost(API.PUBLIC.PASSWORD_UPDATE, this.passwordForm);
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
                this.isPassword = false;
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        }
    },
    created: function () {
        this.getData();
    },
    watch: {
        "$store.state.tabActive": function () {
            let tab = this.$store.state.tabs.filter((tab) => tab.sysPermissionId == this.$store.state.tabActive)[0];
            this.$router.push(tab.sysPermissionUrl);
        }
    }
}
</script>
<style scoped lang="less">
#header-container,
#aside-content {
    padding: 0px !important;
}

#header-container {
    display: flex;
    justify-content: space-between;
}

.header-title {
    width: 200px;
    background-color: rgb(84, 92, 100);
    color: #ffffff;
    height: 60px;
    line-height: 60px;
    padding-left: 20px;
    font-size: 20px;
    font-weight: bold;
    box-sizing: border-box;
}

.header-extend {
    background-color: rgb(84, 92, 100);
    flex-grow: 1;
}

#container-main {
    height: 100vh;
}

#el-container {
    height: calc(100vh - 60px);
}

#aside-menu {
    width: 200px;
    height: calc(100vh - 60px);
    background-color: rgb(84, 92, 100);
    overflow-y: scroll;
    overflow: -moz-scrollbars-none;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

#aside-menu::-webkit-scrollbar {
    width: 0 !important
}

#aside-content {
    width: calc(100vw - 200px);
    height: calc(100vh - 60px);
}

#menu-list {
    width: 200px;
    border: none;
}

#menu-list .el-menu-item {
    width: 200px;
}

.el-menu {
    border-right-width: 0;
}
</style>